/**
 * Return the ordinal representation of a number.
 * @example
 * ordinal(23); // 23 -> 23rd
 * ordinal(11); 11 -> 11th
 *
 * @param {number} num
 * @returns {string}
 */
export default function ordinal(num) {
    if (num >= 11 && num <= 13) {
        return `${num}th`;
    }
    switch (num % 10) {
        case 1:
            return `${num}st`;
        case 2:
            return `${num}nd`;
        case 3:
            return `${num}rd`;
        default:
            return `${num}th`;
    }
}
